var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0.5C1.46957 0.5 0.960859 0.710714 0.585786 1.08579C0.210714 1.46086 0 1.96957 0 2.5V6.5C0 7.03043 0.210714 7.53914 0.585786 7.91421C0.960859 8.28929 1.46957 8.5 2 8.5V2.5H12C12 1.96957 11.7893 1.46086 11.4142 1.08579C11.0391 0.710714 10.5304 0.5 10 0.5H2ZM4 6.5C4 5.96957 4.21071 5.46086 4.58579 5.08579C4.96086 4.71071 5.46957 4.5 6 4.5H14C14.5304 4.5 15.0391 4.71071 15.4142 5.08579C15.7893 5.46086 16 5.96957 16 6.5V10.5C16 11.0304 15.7893 11.5391 15.4142 11.9142C15.0391 12.2893 14.5304 12.5 14 12.5H6C5.46957 12.5 4.96086 12.2893 4.58579 11.9142C4.21071 11.5391 4 11.0304 4 10.5V6.5ZM10 10.5C10.5304 10.5 11.0391 10.2893 11.4142 9.91421C11.7893 9.53914 12 9.03043 12 8.5C12 7.96957 11.7893 7.46086 11.4142 7.08579C11.0391 6.71071 10.5304 6.5 10 6.5C9.46957 6.5 8.96086 6.71071 8.58579 7.08579C8.21071 7.46086 8 7.96957 8 8.5C8 9.03043 8.21071 9.53914 8.58579 9.91421C8.96086 10.2893 9.46957 10.5 10 10.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayIconWhite);
export default __webpack_public_path__ + "static/media/PayIconWhite.9bd3003b034198334de4e1647c4f7acd.svg";
export { ForwardRef as ReactComponent };